<template>
  <div id="continuing" v-loading="loading" X>
    <div>
      <!-- o_ranger:<br />
      左右{{o_ranger.n_viewX}}-{{o_ranger.n_viewX+o_ranger.n_viewWidth}}
      上下{{o_ranger.n_viewY}}-{{o_ranger.n_viewY+o_ranger.n_viewHeight}}<br />
      mover:<br />
      左右{{parseInt(o_ranger.o_mover.n_left)}}-{{parseInt(o_ranger.o_mover.n_right)}}
      上下{{parseInt(o_ranger.o_mover.n_top)}}-{{parseInt(o_ranger.o_mover.n_bottom)}} -->
      <!-- 左侧区域树 -->
      <tree
        :props="{ label: 'name', children: 'areas' }"
        :data="data"
        :expanded="expanded"
        @handleNodeClick="leafSelect"
        ref="region"
      ></tree>
    </div>
    <div class="map" ref="map">
      <!-- 顶部设备切换 -->
      <deviceList @updateLocation="location"></deviceList>
      <!-- 经纬度地图 -->
      <amap
        :data="data"
        :b_showWindow="b_showWindow"
        :markers="markers"
        :icon="icon"
        @markerClick="markerClick"
        ref="amap"
        v-if="screen == 'map'"
        @u_closewindow="b_showWindow = false"
        :zoom="zoom"
      ></amap>
      <div class="view" v-if="screen == 'pic'">
        <!-- 切换大小按钮 -->
        <el-button
          class="togglePicSize"
          @click="u_togglePicSize"
          :icon="s_picSize == 'small' ? 'el-icon-zoom-in' : 'el-icon-zoom-out'"
          circle
          type="info"
        ></el-button>
        <!-- 图片地图 -->
        <div class="scrollArea" ref="scrollArea">
          <div
            class="stage"
            ref="stage"
            :style="{
              width: w + 'px',
              height: h + 'px'
            }"
          >
            <img
              v-default-img
              :src="imgurl"
              alt=""
              @load="load"
              ref="img"
              :style="{
                width: w + 'px',
                height: h + 'px'
              }"
            />
            <div
              class="layer"
              :key="n_areaId"
              v-for="({
                n_areaId,
                areas,
                leftCenter,
                topCenter,
                elementWidth,
                elementHeight,
                name,
                deviceCount,
                offlineCount, // 14
                onlineCount, // 0
                poweroffCount, // 0
                reportCount, // 0
                troubleCount // 0
              },
              index) in mapData"
              @click="picMarkerClick({ name, n_areaId })"
              @mouseover="u_markerMouseover(index)"
              @mouseout="u_markerMouseout()"
              :style="{
                left: (leftCenter * w) / 900 + 'px',
                top: (topCenter * h) / 600 + 'px'
              }"
            >
              <div class="wrapper" v-if="mapData.length > 0">
                <div class="marker" :class="{ marker2: troubleCount > 0 }">
                  <i
                    class="iconfont"
                    :class="icon ? icon : 'iconquanbu'"
                    :style="{
                      color: index == n_areaIndex ? 'red' : '#00ffff'
                    }"
                  ></i>
                </div>
              </div>
            </div>
            <template v-if="mapData.length > 0">
              <!-- 图片地图, 各个设备时的飘窗 -->
              <section
                class="window"
                :class="{ window2: o_curArea.troubleCount > 0 }"
                :style="{
                  left: l + 'px',
                  top: t + 'px'
                }"
                v-if="b_showWindow && n_deviceId != 0"
                @mouseover="u_markerMouseover()"
                @mouseout="u_markerMouseout()"
              >
                <header>
                  {{ o_curArea.name
                  }}<i
                    class="close"
                    style="position:absolute;right:10px;top:0;width:30px;height:30px;"
                    @click="u_closewindow"
                  ></i>
                </header>
                <div class="contain">
                  <row class="sub" _align="middle">
                    <span class="title" @click="goToDevice"
                      ><i class="iconfont iconsum"></i>总数:{{ o_curArea.deviceCount }}</span
                    >
                    <span class="title" @click="isToAlarm"
                      ><i class="iconfont iconsum"></i>告警数:{{ o_curArea.alarmNum }}</span
                    >
                  </row>
                  <ul class="deviceList" v-if="o_curArea.type != 0">
                    <li v-for="o in o_curArea.devices">{{ o.deviceName }}({{ o.device_mark }})</li>
                  </ul>
                </div>
              </section>
              <!-- 图片地图, 全部设备时的飘窗 -->
              <deviceTypesWindow
                :x="l"
                :y="t"
                scope="continuing"
                :pLocation="{
                  width: '216px',
                  height: '124px',
                  left: 'unset',
                  bottom: 'unset'
                }"
                @mouseover.native="u_markerMouseover()"
                @mouseout.native="u_markerMouseout()"
                v-if="n_deviceId == 0"
              ></deviceTypesWindow>
            </template>
          </div>
        </div>
      </div>
      <fengMap
        v-if="screen === 'feng'"
        class="fmap"
        :mapId="rootData.mapNumber"
        :themeId="rootData.url"
        :floorCount="rootData.floorNumber * 1"
        :floorId="rootData.dotNumber * 1"
        :data="rootData.areas || []"
        :autoRotate="true"
      />
    </div>

    <deviceStatistics></deviceStatistics>
  </div>
</template>

<script>
  import Ranger from './Ranger'
  import Mover from './Mover'
  import myRouter from 'Tool/myRouter'
  import { mapState, mapMutations, mapGetters } from 'vuex'
  export default {
    data() {
      return {
        //v-stage
        screen: 'map',
        imgurl: '',
        n_stageHeightByImgRatio: NaN,
        n_imgNaturalWidth: NaN,
        n_imgNaturalHeight: NaN,
        timer: null,
        mapData: [],
        o_mover: new Mover(),
        o_ranger: new Ranger(),
        //el-tree
        data: [],
        //amap
        markers: [],
        //other
        loading: false,
        mousing: false,
        b_showWindow: false,
        icon: '',
        w: '',
        h: '',
        l: '',
        t: '',
        zoom: 8,
        rootData: undefined
      }
    },
    computed: {
      ...mapState('continuing', {
        n_areaId: state => state.n_areaId,
        s_appId: state => state.s_appId,
        n_deviceId: state => state.n_deviceId,
        s_picSize: state => state.s_picSize,
        n_areaIndex: state => state.n_areaIndex
      }),
      ...mapGetters('continuing', {
        expanded: 'a_expand',
        o_curArea: 'o_curArea'
      }),
      list() {
        const that = this
        if (that.o_curArea) {
          return that.o_curArea.deviceTypeStaticList
        } else {
          return []
        }
      },
      n_curMarkerX() {
        const that = this
        if (!that.o_curArea || that.o_curArea.model == 0) {
          return 0
        } else {
          let l = that.o_curArea.areaParameter.leftCenter * (that.w / 900)
          return l
        }
      },
      n_curMarkerY() {
        const that = this
        if (!that.o_curArea || that.o_curArea.model == 0) {
          return 0
        } else {
          let t = that.o_curArea.areaParameter.topCenter * (that.h / 600)
          return t
        }
      }
    },
    methods: {
      ...mapMutations('continuing', {
        changeArea: 'changeArea',
        changeApp: 'changeApp',
        changeDevice: 'changeDevice',
        togglePicSize: 'togglePicSize',
        changeRootData: 'changeRootData',
        changeAreaIndex: 'changeAreaIndex'
      }),
      u_changeRangerSizeByPicSize() {
        const that = this
        if (that.s_picSize === 'small') {
          that.w = that.o_ranger.n_viewWidth
          that.h = that.n_stageHeightByImgRatio
          that.o_ranger.setWidth(that.o_ranger.n_viewWidth)
          that.o_ranger.setHeight(that.n_stageHeightByImgRatio)
        } else {
          that.w = that.n_imgNaturalWidth
          that.h = that.n_imgNaturalHeight
          that.o_ranger.setWidth(that.n_imgNaturalWidth)
          that.o_ranger.setHeight(that.n_imgNaturalHeight)
        }
      },
      locationView() {
        const that = this
        that.$refs['scrollArea'].scrollLeft = that.n_curMarkerX - that.o_ranger.n_viewWidth / 2
        that.$refs['scrollArea'].scrollTop = that.n_curMarkerY - that.o_ranger.n_viewHeight / 2
        that.o_ranger.setViewY(that.$refs['scrollArea'].scrollTop)
        that.o_ranger.setViewX(that.$refs['scrollArea'].scrollLeft)
        that.o_ranger.b_moverIsInViewRange()
      },
      u_togglePicSize() {
        const that = this
        that.togglePicSize()
        that.u_changeRangerSizeByPicSize()

        that.$nextTick(function() {
          that.locationView()
          that.inTheRange()
        })
      },
      u_clearTimer() {
        const that = this
        clearInterval(that.timer)
      },

      u_closewindow() {
        const that = this
        that.b_showWindow = false
        that.u_clearTimer()
      },
      u_openwindow() {
        const that = this
        that.b_showWindow = true
      },
      u_createTimer() {
        const that = this
        that.u_clearTimer()
        that.timer = setInterval(() => {
          if (!that.mapData.length) {
            that.changeAreaIndex(0)
          } else {
            let len = that.mapData.length
            if (len > that.n_areaIndex + 1) {
              that.changeAreaIndex(that.n_areaIndex + 1)
            } else {
              that.changeAreaIndex(0)
              that.inTheRange()
            }
          }
        }, 2000)
      },
      u_markerMouseover(i) {
        const that = this
        that.u_clearTimer()
        that.b_mouseovering = true
        if (i !== undefined) {
          that.changeAreaIndex(i)
        }
        that.u_openwindow()
      },

      u_markerMouseout() {
        const that = this
        that.b_mouseovering = false
        that.u_createTimer()
      },

      //更改当前的地图marker
      pushMarker(rootData) {
        const that = this
        that.markers = []
        var areas = rootData.areas.length > 0 ? rootData.areas : [rootData]
        areas
          .filter(({ deviceCount }) => deviceCount > 0)
          .forEach(o => {
            that.markers.push({
              ...o,
              position: [o.longitude, o.latitude]
            })
          })
        // that.changeArea(rootData.id);
        that.set_area(that.n_areaId)
      },
      load() {
        const that = this
        that.$nextTick(() => {
          //图片原始宽高
          that.n_imgNaturalWidth = that.$refs['img'].naturalWidth
          that.n_imgNaturalHeight = that.$refs['img'].naturalHeight
          //图片比例
          let imgRatio = that.n_imgNaturalHeight / that.n_imgNaturalWidth
          //stage 100% 宽高
          if (!that.o_ranger.n_viewWidth) {
            that.o_ranger.setViewWidth(that.$refs['stage'].offsetWidth)
          }
          if (!that.o_ranger.n_viewHeight) {
            that.o_ranger.setViewHeight(that.$refs['stage'].offsetHeight)
          }
          //stage 按图片比例的高度
          that.n_stageHeightByImgRatio = that.o_ranger.n_viewWidth * imgRatio
          //初始化
          that.u_changeRangerSizeByPicSize()
        })
      },
      mapInit(rootData) {
        //console.log(rootData.url)
        const that = this
        var areas = rootData.areas
        that.mapData = []
        that.imgurl = process.env.API_HOST + rootData.url
        //console.log(that.imgurl)
        if (areas.length == 0 && rootData.deviceCount > 0) {
          //如果没有子区域，就绘制本身
          areas = [rootData]
        }
        that.mapData = areas.map(o => ({
          ...o.areaParameter,
          ...o,
          n_areaId: o.id
        }))
        //that.changeArea(rootData.id);
      },
      ...mapMutations('deviceList', {
        set_area: 'set_area',
        set_systemType: 'set_systemType',
        set_deviceId: 'set_deviceId'
      }),
      isToDevice(name) {
        const that = this
        that.leafSelect()
        let areas = that.$refs.region.$refs.tree.getCurrentNode()
        if (areas.areas) {
          let curNode = that.$refs.region.$refs.tree.getCurrentNode()

          if (curNode && (!curNode.areas || curNode.areas.length == 0)) {
            that.goToDevice()
            return
          }
        }
      },

      goToDevice() {
        const that = this
        that.$router.push({
          path: `/appMonitor/${that.s_appId}/${that.s_appId}Devices`
        })
      },
      isToAlarm() {
        const that = this
        myRouter.push.call(that, 'continuing', 'relaAlarm')
      },

      picMarkerClick(e) {
        const that = this
        console.log(e)
        that.loading = true
        that.changeArea(e.n_areaId)
        that.set_area(that.n_areaId)
        that.isToDevice(e.name)
      },
      markerClick(e) {
        const that = this
        that.loading = true
        that.changeArea(e.id)
        that.set_area(that.n_areaId)
        that.isToDevice(e.name)
      },
      leafSelect(node) {
        const that = this
        if (node) {
          that.changeArea(node.id)
          that.set_area(that.n_areaId)
        }
        that.$nextTick(() => {
          console.log(that.$refs && that.$refs.region)

          if (that.$refs && that.$refs.region) {
            that.$refs.region.$refs.tree.setCurrentKey(that.n_areaId)
          }
          that.location()
        })
      },
      init() {
        var areaAll = JSON.parse(this.$root.areaALL)
        const that = this
        that.active = 0
        let { id, itemId } = that.$route.query
        if (id) {
          that.changeArea(id)
          that.set_area(that.n_areaId)
        }
        that.changeDevice(that.n_deviceId)
        that.set_deviceId(that.n_deviceId)
        that.loading = true

        // console.log(areaAll)
        if (null != areaAll) {
          that.data = areaAll
          //将从后台得到的数据结构改为el-tree所需格式,初始化el-tree
          Promise.resolve().then(a => {
            if (!that.n_areaId) {
              that.changeArea(that.data[0].id)
              that.set_area(that.n_areaId)
            }
            this.$nextTick(() => {
              that.leafSelect()
            })
          })
        } else {
          that.$axiosget('operation/area/selectArea').then(res => {
            that.data = res.data.data

            //将从后台得到的数据结构改为el-tree所需格式,初始化el-tree
            if (!that.n_areaId) {
              that.changeArea(that.data[0].id)
              that.set_area(that.n_areaId)
            }
            that.leafSelect()
            this.$root.areaALL = JSON.stringify(that.data)
          })
        }
      },
      location() {
        const that = this
        that.b_showWindow = false
        that.loading = true
        that
          .$axiosget('operation/monitor/findArea', {
            params: {
              areaId: that.n_areaId,
              deviceTypeId: that.n_deviceId,
              appId: that.s_appId
            }
          })
          .then(res => {
            let rootData = res.data.data
            let a_lengthLg0area = rootData.areas.filter(({ deviceCount }) => deviceCount > 0)
            that.$set(rootData, 'areas', a_lengthLg0area)
            that.rootData = rootData
            that.changeRootData(rootData)
            if (rootData.model == 1) {
              that.screen = 'pic'
              that.o_ranger.setMODE('pic')
              that.$nextTick(() => {
                that.$refs['scrollArea'].addEventListener(
                  'scroll',
                  function() {
                    that.o_ranger.setViewY(that.$refs['scrollArea'].scrollTop)
                    that.o_ranger.setViewX(that.$refs['scrollArea'].scrollLeft)
                  },
                  false
                )
              })
              that.mapInit(rootData)
            } else {
              that.screen = 'map'
              that.o_ranger.setMODE('map')
              that.pushMarker(rootData)
              that.zoom = 8
            }
            if (rootData.model == 2) {
              that.screen = 'feng'
            }
            that.changeAreaIndex(0)
            that.loading = false
          })
      },
      reset() {
        const that = this
        // that.changeArea(0);
        that.changeDevice(that.n_deviceId)
        that.set_deviceId(that.n_deviceId)
        that.changeApp(that.$route.name)
        that.set_systemType(that.s_appId)
      },
      inTheRange() {
        const that = this
        if (!that.$refs['scrollArea']) return

        if (!that.b_mouseovering) {
          that.$refs['scrollArea'].scrollLeft = that.n_curMarkerX - that.o_ranger.n_viewWidth / 2

          that.$refs['scrollArea'].scrollTop = that.n_curMarkerY - that.o_ranger.n_viewHeight / 2
          that.o_ranger.setViewY(that.$refs['scrollArea'].scrollTop)
          that.o_ranger.setViewX(that.$refs['scrollArea'].scrollLeft)
        }

        that.$set(
          that.o_ranger.o_mover,
          'n_left',
          that.n_curMarkerX - that.o_ranger.o_mover.n_width / 2
        )

        that.$set(
          that.o_ranger.o_mover,
          'n_top',
          that.n_curMarkerY - that.o_ranger.o_mover.n_height - 30
        )

        that.o_ranger.b_moverIsInViewRange()
        that.$nextTick(function() {
          that.l = that.o_mover.n_left
          that.t = that.o_mover.n_top
          that.b_showWindow = true
        })
      }
    },
    components: {
      tree: () => import('public/regionTree/tree'),
      amap: () => import('public/amap'),
      deviceStatistics: () => import('./deviceStatistics'),
      deviceList: () => import('./deviceList'),
      deviceTypesWindow: () => import('@/components/dynamicRoute1/home/window'),
      fengMap: () => import('@/components/public/fmap/fmapPainting')
    },
    watch: {
      $route: {
        handler: function() {
          this.reset()
          this.init(true)
        },
        immediate: true
      },
      n_areaIndex: {
        handler: function() {
          this.inTheRange()
        }
      },
      mapData: {
        handler: function() {
          const that = this
          that.changeAreaIndex(0)
          that.u_openwindow()
          that.$set(that.o_mover, 'n_width', 216)
          that.$set(that.o_mover, 'n_height', 124)
          that.$set(that.o_ranger, 'o_mover', that.o_mover)
          if (this.screen == 'pic') {
            that.u_createTimer()
          }
        },
        immediate: true
      }
    },
    mounted() {
      const that = this
      that.reset()
      that.init(true)
    },
    beforeDestroy() {
      this.u_clearTimer()
      this.timer = null
    }
  }
</script>

<style lang="less" scoped>
  #continuing {
    display: flex;
    width: 100%;
    height: 100%;
    padding-top: 20px;
    background: #0c111b;

    .region,
    .map {
      overflow-y: auto;
      height: 100%;
    }
  }

  #continuing .map {
    margin-left: 18px;
    flex: 1;
    padding-top: 56px;
    position: relative;
  }

  .stage {
    width: 100%;
    position: relative;

    img {
      width: 100%;
      height: auto;
    }
  }

  .layer {
    position: absolute;
    cursor: pointer;
  }

  .wrapper {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .marker {
    // background: url("./marker.png") no-repeat center 0;

    &.marker2 {
      // background: url("./marker2.png") no-repeat center 0;
    }

    i {
      font-size: 12px;
    }
  }

  .stage .window {
    width: 216px;
    height: 124px;
    overflow-x: hidden;
    overflow-y: scroll;
    background: url('./window.png') no-repeat center 0;
    margin-bottom: 10px;
    position: absolute;
    transition: 0.5s;

    &.window2 {
      background: url('./window2.png') no-repeat center 0;
    }
  }

  .window header {
    height: 25px;
    line-height: 22px;
    color: #fff;
    font-size: 14px;
    padding-left: 18px;
  }

  .window .contain {
    padding: 10px;
  }

  .window .sub {
    background: #3a4d6c;
    height: 26px;
    line-height: 26px;
    padding: 0 7px;
    position: relative;
  }

  .window .sub .title {
    font-size: 12px;
    color: #fff;
  }

  .window .sub .iconfont {
    font-size: 12px;
    color: #0dcce1;
    margin-right: 6px;
    display: inline-block;
    vertical-align: top;
  }

  .stage .window ul {
    overflow: hidden;
    width: 100%;
  }

  .stage .window li {
    width: 50%;
    float: left;
    padding-left: 32px;
    padding-top: 6px;
    position: relative;
  }

  .stage .window li .iconfont {
    position: absolute;
    font-size: 14px;
    top: 11px;
    left: 10px;
  }

  .stage .window li span {
    color: #fff;
    font-size: 12px;
  }

  .stage .icononline {
    color: #43a876;
  }

  .stage .iconoffline {
    color: #b6b6b6;
  }

  .stage .iconalarm {
    color: #f6be2a;
  }

  .stage .iconwarning {
    color: #d53535;
  }

  .statistics {
    margin-left: 20px;
    width: 260px;
    height: 100%;
    overflow-y: scroll;
  }

  .statistics .el-icon-top-right {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 18px;
    color: #fff;
    cursor: pointer;
  }

  .el-icon-bottom-left {
    position: absolute;
    top: 90px;
    right: 20px;
    width: 30px;
    height: 30px;
    opacity: 0.5;
    line-height: 30px;
    text-align: center;
    font-size: 18px;
    color: #fff;
    cursor: pointer;
    z-index: 9;
  }

  .el-icon-bottom-left:hover {
    opacity: 1;
  }

  .togglePicSize {
    position: absolute;
    left: 50px;
    top: 50px;
    z-index: 99;

    /deep/i {
      font-size: 20px;
    }
  }

  .view {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .scrollArea {
    width: 100%;
    height: 100%;
    overflow: scroll;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/lv2/continuing/index.vue